import type { EligibilityResponse } from "@Light/services/lightTypes";

export function isEligible(result: EligibilityResponse): boolean {
  return result.eligibility_likelihood > 0 && result.utilities.length > 0;
}
